'use strict';

document.addEventListener("DOMContentLoaded", function() {
  
  // 1. Generic accordions
  const faqQuestions = document.querySelectorAll('.faq-question');

  faqQuestions.forEach((question) => {
    question.addEventListener('click', () => {
      // Find the associated answer and arrow
      const answer = question.nextElementSibling.querySelector('.faq-answer');
      const arrow = question.querySelector('.faq-question-arrow');

      // Toggle the 'hidden' class for the answer
      answer.classList.toggle('hidden');

      // Toggle the rotation class for the arrow
      arrow.classList.toggle('rotate-90');
    });
  });

  // 2. Product cards with variants
  const productCards = document.querySelectorAll('.product-card');
  productCards.forEach((card) => {
    const variantsContainer = card.querySelector(".product-variants");
    const productMediaLink = card.querySelector(".product-card-image");
    const productMedia = card.querySelector(".product-card-image img");
    const productTitle = card.querySelector(".product-title");
    const addButton = card.querySelector('button[name="add"]');
    const idField = card.querySelector('input[name="id"]');
    
    if (variantsContainer) {
      const variants = variantsContainer.querySelectorAll(".variant");

      variants.forEach((variant) => {
        variant.addEventListener("click", function () {
          const variantURL = variant.getAttribute("data-url");
          const imageURL = variant.getAttribute("data-image");
          const variantID = variant.getAttribute("data-id");

          variants.forEach((variant2) => {
            if (variant2.classList.contains("active")) {
              variant2.classList.remove("active");
            }
          });

          variant.classList.add("active");

          productMedia.setAttribute("srcset", "");
          productMedia.setAttribute("src", imageURL);

          productMediaLink.setAttribute("href", variantURL);
          productTitle.setAttribute("href", variantURL);

          if (addButton && idField) {
            idField.value = variantID;
          }
        });
      });
    }
  });

  // 3. Generic collapsible
  const collapsibles = document.querySelectorAll(".collapsible");

  collapsibles.forEach((collapsible) => {
    // Find the button and hidden span within the collapsible element
    const button = collapsible.querySelector("button");
    const hiddenContent = collapsible.querySelector(".hidden");

    if (button && hiddenContent) {
      // Add click event listener to the button
      button.addEventListener("click", () => {
        // Remove the 'hidden' class from the span
        hiddenContent.classList.toggle("hidden");
        if (hiddenContent.classList.contains("hidden")) {
          button.textContent = "Visa mer";
        } else {
          button.textContent = "Visa mindre";
        }
      });
    }
  });
  
  // 4. Generic modals
  const modals = document.querySelectorAll('.modal');
  const openModalButtons = document.querySelectorAll('[data-modal-target]');
  const closeModalButtons = document.querySelectorAll('[data-close-button]');

  openModalButtons.forEach(button => {
    button.addEventListener('click', () => {
      const modal = document.querySelector(button.dataset.modalTarget);
      openModal(modal);
    });
  });

  closeModalButtons.forEach(button => {
    button.addEventListener('click', () => {
      const modal = button.closest('.modal');
      closeModal(modal);
    });
  });

  function openModal(modal) {
    if (modal == null) return;
    modal.classList.add('active', 'flex');
    modal.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('modal-is-open');
    document.querySelector('main').classList.remove('z-[1]');
    document.querySelector('main').classList.add('z-[21]');
  }
  function closeModal(modal) {
    if (modal == null) return;
    modal.classList.remove('active', 'flex');
    modal.classList.add('hidden');
    document.body.style.overflow = 'auto';
    document.body.classList.remove('modal-is-open');
    document.querySelector('main').classList.remove('z-[21]');
    document.querySelector('main').classList.add('z-[1]');
  }
  // Close modals on escape key press
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      modals.forEach(modal => {
        if (modal.classList.contains('active')) {
          closeModal(modal);
        }
      });
    }
  });
});
